import { render, staticRenderFns } from "./FilterRevisor.vue?vue&type=template&id=d2568aca"
import script from "./FilterRevisor.vue?vue&type=script&lang=js"
export * from "./FilterRevisor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports